module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-stone-path-remnants.f090a966.png";